<div class="influencer-analytics-container">
    <!-- Heading and Campaign Select -->
    <div class="row">
        <div class="top-customers-container mb-2">
            <h1 i18n="@@influencer_report.top_ordering_customers">Top ordering customers</h1>
            <div class="col-md-2 float-start position-relative">
                <div class="position-relative">
                    <!-- Search Icon -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="position-absolute top-50 start-0 translate-middle-y ms-2" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <!-- Search Input -->
                    <input type="text" class="filters_search ps-5 form-control" 
                        (keyup)="searchInfluencer($event.target.value)" 
                        placeholder="Search" 
                        i18n-placeholder="@@influencer_report.search_here"
                        name="data-table__search--input" 
                        #searchInput>
                </div>
            </div>
        </div>
    </div>

    <!-- Cards Section -->
    <div class="stats-container">
        <div class="stat-card" *ngFor="let stat of stats">
            <div class="label">{{ stat.label }}</div>
            <div class="value">{{ stat.value | number }}</div>

            <div class="d-flex align-items-center gap-2">
                <div class="counter_persent" [ngClass]="{ 'up': stat.isUp, 'down': !stat.isUp }">
                    <!-- Up Arrow -->
                    <svg *ngIf="stat.isUp" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 14 14" fill="none">
                        <path d="M3.459 5.583L7 2.042l3.541 3.541"
                            stroke="#00B050" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7 12V2.142"
                            stroke="#00B050" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <!-- Down Arrow -->
                    <svg *ngIf="!stat.isUp" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                        viewBox="0 0 14 14" fill="none">
                        <path d="M10.541 8.417L7 11.958 3.459 8.417"
                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7 2.042v9.817"
                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <span>{{ stat.isUp ? '+' : '-' }}{{ stat.change }}%</span>
                </div>

                <span class="period" i18n="@@influencer_report.since_yesterday">since yesterday</span>
            </div>
        </div>
    </div>

    <div class="content-container clients_page">
        <div class="table_block">
            <table class="marketing_table clients_item">
                <thead>
                    <tr>
                        <th i18n="@@influencer_report.influencer_name" (click)="sortData('influencer_name')">Influencer Name</th>
                        <th i18n="@@influencer_report.source" (click)="sortData('source')">Source</th>
                        <th i18n="@@influencer_report.orders_started" (click)="sortData('orders_started')">Orders Started</th>
                        <th i18n="@@influencer_report.orders_placed" (click)="sortData('orders_placed')">Orders Placed</th>
                        <th i18n="@@influencer_report.orders_checked_out" (click)="sortData('orders_checked_out')">Orders Checked Out</th>
                        <th i18n="@@influencer_report.order_amount" (click)="sortData('order_amount')">Order Amount</th>
                        <th i18n="@@influencer_report.influencer_payout" (click)="sortData('influencer_payout')">Influencer Payout</th>
                        <th i18n="@@influencer_report.created_at" (click)="sortData('created_at')">Created At</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="data && data.length > 0; else noData">
                        <tr *ngFor="let row of data | paginate: paginator; index as i">
                            <td data-label="Influencer Name">{{ row.influencer_name }}</td>
                            <td data-label="Source">{{ row.source }}</td>
                            <td data-label="Orders Started">{{ row.orders_started }}</td>
                            <td data-label="Orders Placed">{{ row.orders_placed }}</td>
                            <td data-label="Orders Checked Out">{{ row.orders_checked_out }}</td>
                            <td data-label="Order Amount">{{ row.order_amount | number:'1.2-2' }}</td>
                            <td data-label="Influencer Payout">{{ row.influencer_payout | number:'1.2-2' }}</td>
                            <td data-label="Created At">{{ row.created_at | date:'short' }}</td>
                        </tr>
                    </ng-container>
                    <ng-template #noData>
                        <tr>
                            <td colspan="8" class="text-center" i18n="@@influencer_report.no_data_found">No data found</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
            
            <ng-container *ngIf="paginator.totalItems > paginator.itemsPerPage">
                <div class="pagination_wrapper">
                    <div class="showing_results">
                        <div class="select_wrapper">
                            <ng-container i18n="@@influencer_report.show">Show</ng-container>
                            <select class="select-link tab-links-select" id="tab-links-select" nice-select
                                [(ngModel)]="paginator.itemsPerPage" (change)="onChangeItemsPerPage($event, p)">
                                <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                            </select>
                            <ng-container i18n="@@influencer_report.items">items</ng-container>
                        </div>
                        <div class="results_list" *ngIf="paginator?.from || paginator?.to">
                            <ng-container i18n="@@influencer_report.showing_from">Showing from</ng-container> {{ paginator?.from }}
                            <ng-container i18n="@@influencer_report.to">to</ng-container> {{ paginator?.to }}
                            <ng-container i18n="@@influencer_report.of">of</ng-container> {{ paginator?.totalItems }}
                            <ng-container i18n="@@influencer_report.items">items</ng-container>
                        </div>
                    </div>
                    <nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)" aria-label="...">
                        <ul class="pagination justify-content-center">
                            <li class="page-item" [class.disabled]="p.isFirstPage()">
                                <a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
                                    <svg width="7.5" height="13.5">
                                        <path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke"
                                            stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                    </svg>
                                </a>
                            </li>

                            <li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value">
                                <a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
                                    <span>{{ page.label }}</span>
                                </a>
                                <a *ngIf="p.getCurrent() === page.value" class="page-link">{{page.label}}
                                    <span class="sr-only" i18n="@@influencer_report.current">(current)</span></a>
                            </li>

                            <li class="page-item" [class.disabled]="p.isLastPage()">
                                <a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
                                    <svg width="7.5" height="13.5">
                                        <path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round"
                                            stroke-linejoin="round" stroke-width="1.5" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </ng-container>
        </div>
    </div>
</div>